const evaluationSourceTypes = {
  Previa: 1,
  MiPE_Cita: 2,
  Remedio_Provisional: 3,
};

export default evaluationSourceTypes;
